// Explore-stats page: Previous occupations — current Parliament.
// Recreates the Handbook page — horizontal stacked bar of previous
// occupation categories by party, with a category/total table.

import React, { useState, useEffect } from 'react';
import { Paper, Typography } from '@mui/material';
import { getExploreStat } from '../../services/api';
import ExploreStatsPage from './ExploreStatsPage';
import { StatStackedBar } from './charts';

export default function PreviousOccupations() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await getExploreStat('previous-occupations');
        if (active) setData(res);
      } catch (e) {
        if (active) setError(e.message || 'Failed to load statistics');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const charts = data?.charts || {};

  return (
    <ExploreStatsPage
      title="Previous occupations — current Parliament"
      description="The occupations current parliamentarians held before entering Parliament, grouped into categories — highlighting a strong concentration of office, professional and political roles and comparatively few in trades or labouring. Occupations are free text and grouped heuristically."
      loading={loading}
      error={error}
      columns={data?.columns || []}
      rows={data?.table_rows || []}
      links={data?._links || []}
      csvName="previous-occupations"
    >
      {data && (
        <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Previous occupations — current Parliament
          </Typography>
          <StatStackedBar
            data={charts.by_category_party || []}
            xKey="category"
            keys={charts.series || []}
            layout="vertical"
            height={520}
          />
        </Paper>
      )}
    </ExploreStatsPage>
  );
}
